import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { KitPage, KitAppLayout } from '@chargepoint/cp-toolkit';
import Footer from './Footer';
import Header from './Header';

// eslint-disable-next-line react/prop-types
function Page({ title, children }) {
  const { i18n } = useTranslation();

  return (
    <KitPage title={title} locale={i18n.language}>
      <KitAppLayout.Header>
        <Header />
      </KitAppLayout.Header>
      <KitAppLayout.Body>{children}</KitAppLayout.Body>
      <KitAppLayout.Footer>
        <Footer />
      </KitAppLayout.Footer>
    </KitPage>
  );
}

Page.propTypes = {
  children: PropTypes.node,
};

Page.defaultProps = {
  children: undefined,
};

export default Page;
